import { tableCustom } from '@core/containers/table-custom';
import { VEHICLE_TIMELINE_TABLE_CONFIG } from '@common/models/vehicle-timeline/config/table';
import { vehicleTimelines2table } from '@common/models/vehicle-timeline/decorators';
import { ILSCatalogTable } from '../../containers/table-container';
import { IPropsILSCatalogTable } from '@modules/catalog/types/components';
import { FC } from 'react';
import { CatalogDictionary, Dictionary } from '@common/types';
import { table2data } from '@components/data-display/table/utils/decorators/table-to-data';

export const ILSCatalogVehicleTimeline: FC<IPropsILSCatalogTable> = tableCustom(
  (props) => {
    return (
      <ILSCatalogTable
        {...props}
        dictionary={Dictionary.VehicleTimeline}
        dataDecorator={vehicleTimelines2table}
        handleDecorator={table2data}
      />
    );
  },
  VEHICLE_TIMELINE_TABLE_CONFIG,
  CatalogDictionary.VehicleTimeline,
  true
);
